import { fetchResource, fetchOnce } from "../../util/fetch";
import { Service } from "../../service/device/setup";
import { Show } from "solid-js"
import { Spinner, Card, Button, Row, Col } from "solid-bootstrap";

export function LayoutPicker(props) {
    const [theme, refetchTheme] = fetchResource(() => Service.getTheme(props.theme.uuid));
    const layoutPresets = [
        {
            label: "Official Raspberry Pi Touch Display 2 (1280x720)",
            params: {
                "width": 1280,
                "height": 720
            }
        },
        {
            label: "(Legacy) Official Raspberry Pi Touchscreen (800x480)",
            params: {
                "width": 800,
                "height": 480
            }
        },
        // {
        //     label: "3.5\"  TFT Touchscreen (480x320)",
        //     params: {
        //         "width": 480,
        //         "height": 320
        //     }
        // },
        // {
        //     label: "Planner view (800x1024)",
        //     params: {
        //         "width": 800,
        //         "height": 1024
        //     }
        // }
    ];

    function isLoaded() {
        return !theme.loading;
    }

    function makeOnClickHandler(preset) {
        return (e) => {
            Service.getTheme(props.theme.uuid).then(myTheme => {
                Service.applyThemePhysicalLayoutDefaults(myTheme.uuid, preset.params.width, preset.params.height);
            });
        };
    }

    return <>
        <Show when={isLoaded()}>
            <Row g={3}>
                <For each={layoutPresets}>{(preset, i) =>
                    <Col sm="6" md="4" lg="3">
                        <PresetOption bucketFile={preset} onClick={makeOnClickHandler(preset)} />
                    </Col>
                }</For>
            </Row>
        </Show>
        <Show when={!isLoaded()}>
            <Spinner animation="border" />
        </Show>
    </>
}

function PresetOption(props) {
    return <>
        <Card>
            <Card.Body>
                <Card.Title>{props.bucketFile.label}</Card.Title>
                <Button variant="primary" onClick={props.onClick}>Apply</Button>
            </Card.Body>
        </Card>
    </>

}